import { Badge, Tab, TabList } from "@chakra-ui/react";
import HeaderBar from "components/ui/HeaderBar";
import { usePermissionsContext } from "contexts/PermissionsContext";
import { Link } from "react-router-dom";
import { useNewsletterReviewCount } from "../hooks/useNewsletterReviewCount";

export default function Header() {
  const { ability, user } = usePermissionsContext();
  const { data: reviewCount = 0 } = useNewsletterReviewCount();

  return (
    <HeaderBar
      title="Disparos de Newsletters"
      description="Visualize a gerencie os disparos de e-mail Patri"
    >
      {ability.can("review", "Newsletter") && (
        <TabList>
          <Tab as={Link} to="/disparos-de-newsletter">
            Enviadas
          </Tab>

          <Tab as={Link} to="/disparos-de-newsletter/aguardando-revisao">
            Aguardando revisão
            {reviewCount > 0 && (
              <Badge variant="solid" colorScheme="red" ml="2px" mt="-8px">
                {reviewCount}
              </Badge>
            )}
          </Tab>
        </TabList>
      )}
    </HeaderBar>
  );
}
